import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'

import { DepartmentMappers } from '../mappers'
import { DepartmentsService } from '../services'
import { DepartmentFormData } from '../types'

export const useDepartmentFormInitialData = ({ id, initialValues }: { id?: string; initialValues?: DepartmentFormData }) => {
  return useQuery<DepartmentFormData>(
    useCallback(async () => {
      const result = await DepartmentsService.getOneById(id as string)

      if (result.status === 200) {
        return DepartmentMappers.formInitializer(result.data)
      } else {
        return initialValues
      }
    }, [initialValues, id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: initialValues,
        enabled: !!id,
      }),
      [initialValues, id],
    ),
  )
}
